import { Injectable } from '@angular/core';
import { API_URL } from 'src/app/config/api.constant';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/internal/operators/map';
import { CheckClaimModel, CheckClaimOkDateModel } from 'src/app/shared/models/check-claim-status.model';
import { PrintDocTypeModel } from 'src/app/shared/models/print-doc-type.model';
import * as Config from 'src/app/config/app.constant';

@Injectable({
  providedIn: 'root'
})
export class CkeckClaimServiceService {

  constructor(private http: HttpClient) { }

  public searchClaimStatus(param: CheckClaimModel) {
    return this.http.post(`${API_URL.searchClaimStatus}`, param, Config.HTTP_OPTIONS_SMARTCLAIM).pipe(map((res) => res));
  }

  public printDoc(params: PrintDocTypeModel) {
    return this.http.post(`${API_URL.printDoc}`, params, Config.HTTP_OPTIONS_SMARTCLAIM).pipe(map((res) => res));
  }

  public uploadFile(params: any) {
    return this.http.post(`${API_URL.uploadFile}`, params, Config.HTTP_OPTIONS_SMARTCLAIM).pipe(map((res) => res));
  }

  public searchApprovedDate(param: CheckClaimOkDateModel) {
    return this.http.post(`${API_URL.searchClaimOkDate}`, param, Config.HTTP_OPTIONS_SMARTCLAIM).pipe(map((res) => res));
  }

}
